import React, { useState, useEffect } from 'react';
import AddBarrio from './AddBarrio';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
function GestionBarrios() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [barrios, setBarrios] = useState([]);
    const [editBarrio, setEditBarrio] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [barrioToDelete, setBarrioToDelete] = useState(null);
    const { user } = useUser();

    useEffect(() => {
        fetchBarrios();
    }, []);

    const fetchBarrios = async () => {
        try {
            const response = await fetch(`${server}/MgBarriosColonias`);
            const data = await response.json();
            setBarrios(data.$values);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar los barrios: ' + error,
            });
        }
    };

    const handleNewBarrio = () => {
        fetchBarrios();
        setEditBarrio(null);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleOpenDialog = (barrio) => {
        setBarrioToDelete(barrio);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setBarrioToDelete(null);
    };

    const handleDeleteBarrio = async () => {
        if (barrioToDelete) {
            try {
                const username = ''+user.codigoUsuario+'/';

                const response = await fetch(`${server}/MgBarriosColonias/${barrioToDelete.idBarrioColonia}/${username}`, { method: 'DELETE' });
                if (response.ok) {
                    handleCloseDialog();
                    fetchBarrios();
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: 'Barrio eliminado con éxito',
                    });
                } else {
                    handleCloseDialog();

                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al eliminar el Barrio: ' + error,
                });
            }
        }
    };

    const filteredBarrios = barrios.filter(barrio => barrio.nombreBarrioColonia?.toLowerCase().includes(searchQuery.toLowerCase()));
    return (
        <>
            <div className="x_title">

            </div>
            <div className="x_content">
                <br />
                <AddBarrio handleNewBarrio={handleNewBarrio} editBarrio={editBarrio} />
                <div className="ln_solid" />

                <h2>Barrios / Colonias Existentes</h2>
                <div className="row">
                    <div className="col-md-9 col-sm-4 offset-md-2">
                        <TextField
                            variant="outlined"
                            label="Buscar barrio"
                            fullWidth
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginBottom: '20px' }}
                        />
                        <div className="table-responsive">
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Nombre Barrio o Colonia</TableCell>
                                            <TableCell>Municipio</TableCell>
                                            <TableCell>Departamento</TableCell>
                                            <TableCell>País</TableCell>
                                            <TableCell>Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredBarrios.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((barrio) => (
                                            <TableRow key={barrio.idBarrioColonia}>
                                                <TableCell>{barrio.nombreBarrioColonia}</TableCell>
                                                <TableCell>{barrio.nombreMunicipio}</TableCell>
                                                <TableCell>{barrio.nombre_departamento}</TableCell>
                                                <TableCell>{barrio.nombre_pais}</TableCell>
                                                <TableCell>
                                                    <Button onClick={() => setEditBarrio(barrio)} color="primary" disabled={!tienePermiso('Editar Barrio')}>Editar</Button>
                                                    <Button onClick={() => handleOpenDialog(barrio)} color="secondary" disabled={!tienePermiso('Eliminar Barrio')}>Eliminar</Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25,50,100]}
                                    component="div"
                                    count={filteredBarrios.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                            <Dialog
                                open={openDialog}
                                onClose={handleCloseDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle>{"Confirmar eliminación"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        ¿Estás seguro de que deseas eliminar este barrio?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                    <Button onClick={handleDeleteBarrio} color="primary" autoFocus>Eliminar</Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GestionBarrios